import { createService } from '@betty/toolkit/api';
import {
  GamesResponseSchema,
  SearchResultsSchema,
  GameInfoSchema,
} from '../shared/games.schemas';
import { Game } from '../../state/shared/games.types';

export default {
  ...createService(
    {
      getGames: {
        method: 'GET',
        url: '/lobby/games',
        headers: {
          'x-api-version': '2',
        },
        responseSchema: GamesResponseSchema,
      },
      getSearchResults: {
        method: 'GET',
        headers: {
          'x-api-version': '2',
        },
        url: '/lobby/games/search',
        responseSchema: SearchResultsSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getPublicGames: {
      method: 'GET',
      url: '/lobby/games',
      headers: {
        'x-api-version': '2',
      },
      public: true,
      responseSchema: GamesResponseSchema,
    },
    getPublicSearchResults: {
      method: 'GET',
      headers: {
        'x-api-version': '2',
      },
      url: '/lobby/games/search',
      public: true,
      responseSchema: SearchResultsSchema,
    },
    getGameInfo: {
      method: 'GET',
      url: ({ gameId }: { gameId: Game['id'] }) => `/Games/${gameId}`,
      public: true,
      responseSchema: GameInfoSchema,
    },
  }),
};
